export default __webpack_public_path__ + "static/media/P940_P941_P942_P943_P944_P945_P946_P948_P978_SOV.ae6e14da.pdf";